import { budgetSpent, BUDGET } from "../../utils/football";

export const BudgetTracker = ({ squad }) => {
  const spent = budgetSpent(squad);
  const remaining = BUDGET - spent;
  const pct = Math.min((spent / BUDGET) * 100, 100);
  const over = remaining < 0;
  return (
    <div className="football-theme rounded-xl border border-border bg-card p-3" data-testid="budget-tracker">
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          Budget <strong className={over ? "text-red-400" : "wc-gold"} data-testid="budget-remaining">{remaining.toFixed(1)}Cr</strong> left
        </span>
        <span className="text-muted-foreground">Spent {spent.toFixed(1)}Cr</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
        <div
          className={`h-full rounded-full transition-all duration-300 ${over ? "bg-red-500" : "wc-bg-gold"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default BudgetTracker;
